import { type ReactNode } from 'react'
import { message } from 'antd'
import { CheckCircleFilled, CloseCircleFilled, InfoCircleFilled } from '@ant-design/icons'
import './notify.css'

message.config({ top: 28, duration: 2.5, maxCount: 3 })

type Kind = 'success' | 'error' | 'info'

const COLORS: Record<Kind, string> = { success: '#059669', error: '#DC2626', info: '#2563EB' }
const ICONS: Record<Kind, ReactNode> = {
  success: <CheckCircleFilled />,
  error: <CloseCircleFilled />,
  info: <InfoCircleFilled />,
}

const toast = (kind: Kind, title: string, subtitle?: string) => {
  message.open({
    className: `sp-toast-notice sp-toast-${kind}`,
    content: (
      <span className="sp-toast">
        <span className="sp-toast-ic" style={{ color: COLORS[kind] }}>{ICONS[kind]}</span>
        <span className="sp-toast-body">
          <span className="sp-toast-title">{title}</span>
          {subtitle ? <span className="sp-toast-sub">{subtitle}</span> : null}
        </span>
      </span>
    ),
  })
}

/** Polished success toast — e.g. notifySuccess('Logged in', 'Welcome back, Admin'). */
export const notifySuccess = (title: string, subtitle?: string) => toast('success', title, subtitle)
export const notifyError = (title: string, subtitle?: string) => toast('error', title, subtitle)
export const notifyInfo = (title: string, subtitle?: string) => toast('info', title, subtitle)
